import React, { useEffect, useRef, useState } from 'react';
import Avatar from '../Avatar';

const TypingIndicator = ({ people }) => {
    const ref = useRef(null);
    const [visible, setVisible] = useState(true);
    const [pageVisible, setPageVisible] = useState(!document.hidden);
    const hasPeople = people.length > 0;

    useEffect(() => {
        const onVisibility = () => setPageVisible(!document.hidden);
        document.addEventListener('visibilitychange', onVisibility);
        return () => document.removeEventListener('visibilitychange', onVisibility);
    }, []);

    useEffect(() => {
        if (!ref.current || !window.IntersectionObserver) return undefined;
        const observer = new IntersectionObserver(([entry]) => setVisible(entry.isIntersecting));
        observer.observe(ref.current);
        return () => observer.disconnect();
    }, [hasPeople]);

    if (!hasPeople) return null;
    return (
        <div ref={ref} className="msgr-typing-people" data-animate={visible && pageVisible}>
            {people.map(person => (
                <div key={person.id} className="msgr-typing-row" role="status" aria-label={`${person.name} is typing`}>
                    <Avatar name={person.name} profilePic={person.profilePic} className="msgr-typing-avatar" />
                    <div className="msgr-typing-bubble" aria-hidden="true">
                        <span /><span /><span />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default TypingIndicator;
